
export default {
  data() {
    return {
      currentCellId: 0,
      previewVisible: false,
    };
  },
  mounted() {
  },
  methods: {
    handlePreview({ id }) {
      this.currentCellId = id;
      this.previewVisible = true;
    },
    handleClosePreview() {
      this.previewVisible = false;
    },
  },
};
